
import axios from '../../functions/axios';
import { useState, useEffect } from 'react';
import editButton from '../../assets/images/editButton.png';
import { useNavigate } from "react-router-dom";
import style from './User.module.css';
import { useAuthContext } from '../../hooks/useAuthContext';

function UserList(props) {
  const [apiData, setApiData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const { user } = useAuthContext();


  const getUsersData = async () => {
    if (!user) return null;
    try {
      const { data: response } = await axios.get(`/users`);
      setApiData(response);
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleEditUsers = (user) => {
    navigate('/editUserByAdmin', { state: user });
  };

  const handleFilterUsers = (searchQuery) => setSearchQuery(searchQuery.trim().replace(/\s+/, '').toLowerCase());
  useEffect(() => getUsersData(), [user]);

  return (
    <>
      <div className={style.menu}>
        <div className={style.filter}>
          <p>Wyszukaj Użytkownika:</p>
          <input type="search" className="form-control" placeholder="User" onChange={(e) => handleFilterUsers(e.target.value)}></input>
        </div>
        <button className="btn btn-default" onClick={navigate.bind(null, '/register')}>Dodaj użytkownika</button>
      </div>
      <div className={style.container}>
        {
          apiData
            .filter(user => !user.name)
            .filter((user) => {
              if (searchQuery === '')
                return true;
              return user.userName.toLowerCase().includes(searchQuery);
            })
            .sort((...args) => {
              const [a, b] = args.map((user) => user.userName);
              return a.localeCompare(b, 'pl', { sensitivity: 'base' });
            })
            .map((user, index) =>(
              <div className={style.users} key={index}>
                <span className={style.userName}>{user.userName}</span>
                <span className={style.surName}>{user.surName }</span>
                <img className={style.editButton} src={editButton} onClick={handleEditUsers.bind(null, user)} />
              </div>
            ))}
      </div>
    </>
  );
}

export default UserList;